module.exports = __webpack_public_path__ + "static/media/1022738.4a73660d.jpg";